export default {
  ACTIVE: 'active',
  HIDDEN: 'hidden',
  SOLD: 'sold',
  REMOVED: 'removed',
};
